import { WorkspaceRoleSchema } from "./workspace-role";
import { z } from "zod";
export const MAX_MEMBERS_COUNT = 100;
export const UserInvite = z.object({
    email: z
        .string()
        .email()
        .trim()
        .transform((value) => value.toLowerCase()),
    role: WorkspaceRoleSchema,
});
export const UserInvites = z.array(UserInvite).max(MAX_MEMBERS_COUNT);
